import React from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import {FormId_Contact , CLIENT_ID} from '../config.js'
import GetForm from './GetForm'
import { getItemAnonymous} from '../actions/user'
import { connect } from 'react-redux';
import {GET_FORM, SUBMIT_FORM,CREATE_FORM_ENTRIE} from '../actions/user';
import { UncontrolledAlert } from 'reactstrap';
import  Sidebar from "./Sidebar";

class PageContact extends React.Component {
constructor(props){
  super(props);
  this.state={
    spinner_status:false,
  }
}
componentDidMount(){
    const url ='v1/forms/'+FormId_Contact+'/view/?client='+CLIENT_ID;
    this.setState({spinner_status:true});
    this.props.getItemAnonymous(url, GET_FORM);
  }
componentWillReceiveProps(nextProps) {
    this.setState({spinner_status:nextProps.spinner_status});
 }
    render() {
      const success  = this.props.success ? this.props.success :null;
      console.log('test mes' , {success});
    return (
	<div>

     <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.0157696494757!2d-17.470614185158478!3d14.711700289731814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec172a4a47b525b%3A0x250389427be60011!2sCit%C3%A9+Keur+Gorgui%2C+Dakar!5e0!3m2!1sfr!2ssn!4v1539285153020" width="100%" height="250" frameborder="0" className="iframe_ inner_page_background" allowfullscreen></iframe>

   <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                
                     
                        <div className="col-md-8">
                      <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/>  Nous contacter</h3>
              
                     {this.props.success ?
                      <UncontrolledAlert color="success">
                          {this.props.success}
                      </UncontrolledAlert>
                      :
                      this.props.error ?
                        <UncontrolledAlert color="danger">
                           {this.props.error}
                      </UncontrolledAlert>
                        : null
                    
                    }


                        <GetForm fields={this.props.fields} title={this.props.title} 
                        formId={FormId_Contact} clientId={CLIENT_ID} spinner_status={this.state.spinner_status}
                        textbtn="Envoyer votre message"/>
                     
                       
                    </div>
                  <div className="col-lg-4 sidebar">
          
                      <div className="info_contact">
                             <h1> Nous localiser</h1>
                         <p>Rond Point Cité Keur Gorgui Immeuble El Hadji Fallou LO Dakar - SENEGAL</p>
                          <ul className="link-small">
                              <li><a className="lowercase" href="mailto:contact@greenagrobusiness.com"><i className="fa fa-envelope"></i>contact@greenagrobusiness.com</a></li>
                              <li><a className="telephone"><i className="fa fa-phone left"></i>+221 33 825 74 44</a></li>
                          </ul>
                        
                     
                        
                      </div>

              </div> 
                    </div>
                
                </div>
            
        
        </section>



    </div>


  )
 }
}
function mapStateToProps(state, ownProps){
  return {
    fields: state.dynamicform.fields,
    title: state.dynamicform.title,
    success: state.dynamicform.success,
    error: state.dynamicform.error,
    spinner_status:state.dynamicform.spinner_status,

  }
}  
export default connect(mapStateToProps, {getItemAnonymous})(PageContact);




// WEBPACK FOOTER //
// ./src/components/Contact.jsx